import { Component } from '@angular/core';

@Component({
  selector: 'custom-divider',
  templateUrl: './custom-divider.component.html'
})
export class CustomDividerComponent {

}
